import * as React from 'react';
import { useRef, useEffect } from 'react';

const FlashComponent = () => {
    const myRef = useRef(null);
    const playVideo = () => {
        myRef.current.play();
    }

    useEffect(() => {
        playVideo();
    })

    return (
        <div className="page-padding">
            <video className="top-video" autoPlay muted loop ref={myRef}>
                <source  src="/top.mp4" type="video/mp4"  />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default FlashComponent;
